import { Selector, type SelectorProps } from "@/ds/custom/Selector";

export const HeaderBarSelector = <T extends string>(props: Omit<SelectorProps<T>, "className">): React.JSX.Element => {
	return (
		<Selector className="w-full @md:w-auto" {...props} />
	);
};
